import React from 'react';
import { Link } from 'react-router-dom';

export const Home = () => {
    return (
        <div className='text-center'>
            <h1>Bar El Quijote</h1>

            <p>Bienvenido a nuestra web, aunque estamos preparando el contenido, pero de momento, te invitamos a consultar <Link to="/carta" className='global-link'>nuestra carta</Link>.</p>

            <p>Nuestro horario:</p>

            <p>
                Lunes a Viernes: <b>8h a 16h</b><br />
                Sádados: <b>9h a 16h</b><br />
                Domingos: <b>cerrado</b>
            </p>
        </div>
    );
}

